import type { FlexProps, SegmentedControlProps } from '@byecode/ui'
import { SegmentedControl, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

interface FormSegmentedControlProps extends SegmentedControlProps {
    label?: React.ReactNode
    color?: string
    wrapperProps?: FlexProps
}

const StyledSegment = styled(SegmentedControl)`
    /* flex: 0 0 182px; */
`

/** SegmentedControl表单项组件 */
const FormSegmentedControl = forwardRef<HTMLDivElement, FormSegmentedControlProps>(({ label, wrapperProps, color, ...rest }, ref) => {
    return (
        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center" {...wrapperProps}>
            {label && <Text color={color}>{label}</Text>}
            <div style={{ width: 180 }}>
                <StyledSegment ref={ref} fullWidth {...rest} />
            </div>
        </ListItem4ByecodeUi>
    )
})

export default FormSegmentedControl
